import Page from "webPage/Page";
import PromiseHelper from "base/PromiseHelper";

Page.register('/news', () => {

    let request;

    $('body').on("click", ".js-load-more", function () {
        let offset = parseInt($(this).attr('data-offset'));
        loadMorePosts(offset);
        return false;
    });

    function loadMorePosts(offset) {
        let $btn = $('.js-load-more');
        if ($btn.is('.btn--loading')) return;

        let $holder = $('.js-news-articles');
        $btn.addClass('btn--loading');

        let limit = 8;

        let data = {
            limit: limit,
            offset: offset
        };

        let request = Ajax.get('content', '59694fd541f4ed28/posts/search', data, Ajax.WEBSITE);

        PromiseHelper.delayed_promise(request, 800).then((data) => {
            console.log(data);
            $btn.removeClass('btn--loading');

            if (data.pages.current >= data.pages.max) {
                $btn.hide();
            } else {
                $btn.show().attr('data-offset', ((data.pages.current * data.pages.perPage)));
            }

            if (data.results.length > 0) {

                data.results.map((result, index) => {

                    let additionalClasses = '';
                    let sizes = '(min-width: 1200px) calc((100vw - 20.84vw) / 100 * 24.25), (min-width: 960px) calc((100vw - 10.42vw - 44px) / 2), (min-width: 760px) calc((100vw - 3.91vw - 44px) / 2), (min-width: 600px) calc((100vw - 54px) / 2), calc(100vw - 20px)';

                    if (index % 7 === 0) {
                        additionalClasses = 'article--extra-big';
                        sizes = "(min-width: 1200px) calc((100vw - 20.84vw) / 100 * 62), (min-width: 960px) calc((100vw - 10.42vw - 44px) / 2), (min-width: 760px) calc((100vw - 3.91vw - 44px) / 2), (min-width: 600px) calc((100vw - 54px) / 2), calc(100vw - 20px)";
                    } else if (index % 6 === 0) {
                        additionalClasses = 'article--big';
                        sizes = "(min-width: 1200px) calc((100vw - 20.84vw) / 100 * 36.93), (min-width: 960px) calc((100vw - 10.42vw - 44px) / 2), (min-width: 760px) calc((100vw - 3.91vw - 44px) / 2), (min-width: 600px) calc((100vw - 54px) / 2), calc(100vw - 20px)";
                    } else if (index === 1 || index % 9 == 0) {
                        additionalClasses = 'article--big-early';
                        sizes = "(min-width: 1200px) calc((100vw - 20.84vw) / 100 * 36.93), (min-width: 960px) calc((100vw - 10.42vw - 44px) / 2), (min-width: 760px) calc((100vw - 3.91vw - 44px) / 2), (min-width: 600px) calc((100vw - 54px) / 2), calc(100vw - 20px)";
                    } else if (index === 0 || index % 8 == 0) {
                        additionalClasses = 'article--offset article--extra-big-early';
                        sizes = "(min-width: 1200px) calc((100vw - 20.84vw) / 100 * 62), (min-width: 960px) calc((100vw - 10.42vw - 44px) / 2), (min-width: 760px) calc((100vw - 3.91vw - 44px) / 2), (min-width: 600px) calc((100vw - 54px) / 2), calc(100vw - 20px)";
                    }

                    let random_id = get_default_news_image(result.id);

                    console.log(random_id);

                    let $img = result.activeRevision.values['main-image'] === null ? (eotwJSXFactory('img', {'data-object-fit': "cover", className: "img-full",
                                                                                           src: '/images/jpeg/hero-news-inner--' + random_id + '--1730.jpg',
                                                                                           srcSet: '/images/jpeg/hero-news-inner--' + random_id + '--500.jpg 500w, /images/jpeg/hero-news-inner--' + random_id + '--500--2x.jpg 1000w, /images/jpeg/hero-news-inner--' + random_id + '--740.jpg 740w, /images/jpeg/hero-news-inner--' + random_id + '--740--2x.jpg 1480w, /images/jpeg/hero-news-inner--' + random_id + '--1000.jpg 1000w, /images/jpeg/hero-news-inner--' + random_id + '--1000--2x.jpg 2000w, /images/jpeg/hero-news-inner--' + random_id + '--1200.jpg 1200w, /images/jpeg/hero-news-inner--' + random_id + '--1200.jpg 2400w, /images/jpeg/hero-news-inner--' + random_id + '--1400.jpg 1400w, /images/jpeg/hero-news-inner--' + random_id + '--1400.jpg 2800w, /images/jpeg/hero-news-inner--' + random_id + '--1600.jpg 1600w, /images/jpeg/hero-news-inner--' + random_id + '--1600--2x.jpg 3200w, /images/jpeg/hero-news-inner--' + random_id + '--1730.jpg 1730w, /images/jpeg/hero-news-inner--' + random_id + '--1730--2x.jpg 3460w',
                                                                                           sizes: sizes})) :
                        (eotwJSXFactory('img', {'data-object-fit': "cover", className: "img-full",
                              src: result.activeRevision.values['main-image'].href + '.' + result.activeRevision.values['main-image'].customData.extension,
                              srcSet: result.activeRevision.values['main-image'].srcset,
                              sizes: sizes}));

                    let draft = result.activeRevision.values.status.length > 0 && result.activeRevision.values.status[0].slug === 'draft' ? (
                        eotwJSXFactory('span', {className: "admin-draft-button"}, ["DRAFT"])
                    ) : undefined;

                    $holder.append(
                        eotwJSXFactory('article', {className: "article " + additionalClasses}, [
                            eotwJSXFactory('a', {href: "/news/" + result.slug, className: "article__link focus-within"}, [
                                eotwJSXFactory('div', {className: "article__image"}, [
                                    eotwJSXFactory('div', {className: "article__image-height"}),
                                    $img,
                                    eotwJSXFactory('span', {className: "article__lines"}),
                                    draft
                                ]),
                                eotwJSXFactory('div', {className: "article__body"}, [
                                    eotwJSXFactory('h3', {unsafeHtml: result.activeRevision.values.title}),
                                    eotwJSXFactory('p', null, [result.activeRevision.values.snippet]),
                                    eotwJSXFactory('span', {className: "read-more read-more--article"}, [
                                        "Read More",
                                        eotwJSXFactory('span', {className: "svg-icons read-more__icon"}).html('<svg><use xlink:href="/includes/svg-icons.svg#arrow"></use></svg>')
                                    ])
                                ])
                            ])
                        ])
                    );
                });
            } else {
                $btn.hide();
            }
        }).catch((e) => {
            console.log(e);
            $btn.removeClass('btn--loading');
            alert('Something went wrong message');
        });
    }

    function get_default_news_image(id) {
        id = parseInt(id.substr(0, 3), 16);
        return ((id % 6) + 1);
    }

});
